function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import style, { AvatarContainer, Image } from './Avatar.style';
import Badge from '../Badge/Badge';
import { jsx as ___EmotionJSX } from "@emotion/core";

const Avatar = ({
  size,
  name,
  online,
  src,
  colourSeed,
  className,
  attributes: {
    container: containerAttributes
  },
  events
}) => {
  const hasImage = !!src;
  const [isLoaded, setLoaded] = useState(false);
  return ___EmotionJSX(AvatarContainer, _extends({
    size: size,
    hasImage: hasImage,
    name: colourSeed || name,
    className: className
  }, containerAttributes, events), hasImage ? ___EmotionJSX(Image, {
    size: size,
    src: src,
    alt: name,
    onLoad: () => setLoaded(true)
  }) : ___EmotionJSX("span", {
    "aria-hidden": "true",
    css: style.text.base
  }, name && name[0]), hasImage && !isLoaded && ___EmotionJSX(CircularProgress, {
    size: 24
  }), online && ___EmotionJSX(Badge, {
    "aria-label": "online-status",
    css: style.onlineIndicator.base
  }));
};

Avatar.defaultProps = {
  size: 'medium',
  online: false,
  src: null,
  colourSeed: null,
  className: undefined,
  attributes: {},
  events: {}
};
Avatar.propTypes = {
  /** The size of the avatar */
  size: PropTypes.oneOf(['small', 'medium', 'large', 'xLarge']),

  /** Name of the avatar's user, for placeholder avatar. */
  name: PropTypes.string.isRequired,

  /** Used for indicating online status of the user */
  online: PropTypes.bool,

  /** URL of the avatar image */
  src: PropTypes.string,

  /** String used as the seed to pick a background colour for the avatar.
  A correlation id, request id or user id would be an appropriate value. */
  colourSeed: PropTypes.string,
  className: PropTypes.string,
  attributes: PropTypes.shape({
    container: PropTypes.object
  }),
  events: PropTypes.shape({
    onKeyPress: PropTypes.func
  })
};
export default React.memo(Avatar);
//# sourceMappingURL=Avatar.js.map